import Vue from 'vue';
import * as types from './mutation-types';
import * as getters from './getters';

export default {
  // AUTH MUTATIONS
  [types.SET_AUTH_LOADING](state) {
    state.authStatus = 'loading';
  },
  [types.SET_AUTH_SUCCESS](state, payload) {
    state.authStatus = 'success';
    state.token = payload;
  },
  [types.SET_USER](state, payload) {
    state.user = payload;
  },
  [types.SET_AUTH_ERROR](state) {
    state.authStatus = 'error';
  },
  [types.SET_LOGOUT](state) {
    state.authStatus = '';
    state.token = '';
  },

  // CANVAS STATE
  [types.SAVE_CANVAS](state, payload) {
    state.canvasData = payload;
  },
  [types.CLEAR_CANVAS](state) {
    state.canvasData = null;
  },

  // AUDIO RECORDING MUTATIONS
  [types.SET_AUDIO_BUFFER](state, audioBuffer) {
    state.audioBuffer = audioBuffer;
  },
  [types.SET_AUDIO_BUFFER_DECODED](state, audioBufferDecoded) {
    state.audioBufferDecoded = audioBufferDecoded;
  },
  [types.SET_AUDIO_BUFFER_DECODING](state, audioBufferDecoding) {
    state.audioBufferDecoding = audioBufferDecoding;
  },
  [types.SET_AUDIO_DATA_URL](state, audioDataUrl) {
    state.audioDataUrl = audioDataUrl;
  },
  [types.CLEAR_AUDIO_DATA](state) {
    state.audioBuffer = null;
    state.audioBufferDecoded = null;
    state.audioBufferDecoding = false;
    state.audioDataUrl = null;
  },
  [types.SET_JOB_DATA](state, { id, data }) {
    const job = getters.getJobById(state)(id);
    if (job) {
      Object.keys(data).forEach((key) => {
        Vue.set(job, key, data[key]);
      });
    }
  },
  [types.SET_USER_DATA](state, data) {
    if (state.user) {
      Object.keys(data).forEach((key) => {
        Vue.set(state.user, key, data[key]);
      });
    }
  },
};
